import { render, staticRenderFns } from "./DashboardWishlist.vue?vue&type=template&id=1c0de282&"
import script from "./DashboardWishlist.vue?vue&type=script&lang=js&"
export * from "./DashboardWishlist.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWishlist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports